export default "__VITE_ASSET__DtOU9DDj__"